/**
 * What opens the office dashboard.
 *
 * The dashboard is a set of cards, each behind the permission that reads it —
 * students, teachers, classes, parents, attendance, exams, results. Holding any
 * one of them is reason enough to land there; the cards somebody may not see
 * are simply not drawn. Demanding all of them would mean a school whose plan
 * leaves out attendance loses the whole dashboard rather than one card.
 *
 * Kept in step with `OFFICE_DASHBOARD_CODES` in `routers/dashboards.py`.
 */
export const OFFICE_DASHBOARD_CODES = [
  'student.read',
  'teacher.read',
  'class.read',
  'parent.read',
  'attendance.view',
  'exam.read',
  'result.view'
] as const;
